export default class PublicacaoListController {
  constructor($state, Group, UIService, Publicacao, PublicacaoService, PublicacaoTipo, Investigador, User, AreaInterdisciplinar, Revista, GrupoInvestigacao) {
    this.$state = $state;
    this.Group = Group;
    this.UI = UIService;
    this.Publicacao = Publicacao;
    this.PublicacaoService = PublicacaoService;
    this.PublicacaoTipo = PublicacaoTipo;
    this.Investigador = Investigador;
    this.User = User;
    this.AreaInterdisciplinar = AreaInterdisciplinar;
    this.Revista = Revista;
    this.GrupoInvestigacao = GrupoInvestigacao;

    this.dataLoaded = false;

    this.simnao = [{ name: "Sim", value: 1 }, { name: "Não", value: 0 }];
    this.tipos = [];
    this.users = [];
    this.investigadores = [];
    this.areas = [];
    this.revistas = [];
    this.gruposInvestigacao = [];
    this.filtersLoaded = [1, 0, 0, 0, 0, 0, 0];

    this.opt = $state.params;

    this.displayColumns = [
      { displayName: 'ID SGI', name: 'id', visible: false, sortable: true },
      { displayName: 'Título', name: 'titulo', visible: true, sortable: true },
      { displayName: 'Revista', name: 'revista', visible: true, sortable: true },
      { displayName: 'Título do Livro/Revista/Conferência', name: 'tituloSupra', visible: false, sortable: true },
      { displayName: 'Slug', name: 'slug', visible: false, sortable: true },
      { displayName: 'Ano', name: 'ano', visible: true, sortable: true },
      { displayName: 'Tipo de Publicação', name: 'tipo', visible: true, sortable: true },
      { displayName: 'Repositório', name: 'repositorio', visible: false, sortable: true },
      { displayName: 'DOI Short', name: 'doiShort', visible: false, sortable: true },
      { displayName: 'DOI WWW', name: 'doiWww', visible: true, sortable: true },
      { displayName: 'SCOPUS', name: 'scopus', visible: false, sortable: true },
      { displayName: 'ISBN', name: 'isbn', visible: false, sortable: true },
      { displayName: 'ISSN', name: 'issn', visible: false, sortable: true },
      { displayName: 'Ranking Journal à data Pub.', name: 'rankingJournal', visible: true, sortable: true },
      { displayName: 'Highly Cited Paper', name: 'cited', visible: false, sortable: true },
      { displayName: 'Different Institutions Authors', name: 'differentInstitutionsAuthors', visible: false, sortable: true },
      { displayName: 'Open Access', name: 'openAccess', visible: false, sortable: true },
      { displayName: 'In Special Issue', name: 'specialIssue', visible: false, sortable: true },
      { displayName: 'In Proceedings International Conference', name: 'internationalConference', visible: false, sortable: true },
      { displayName: 'Citizen science approach', name: 'citizenScienceApproach', visible: false, sortable: true },
      { displayName: 'Performed public consultation', name: 'performedPublicConsultation', visible: false, sortable: true },
      { displayName: 'Addresses social justice', name: 'socialJustice', visible: false, sortable: true },
      { displayName: 'With foreign authors', name: 'internationalCollaboration', visible: false, sortable: true },
      { displayName: 'Authors developing countries', name: 'developingCountries', visible: false, sortable: true },
      { displayName: 'Authors from industry', name: 'industry', visible: false, sortable: true },
      { displayName: 'Criado por', name: 'criadoPor', visible: false, sortable: true },
      { displayName: 'Completa?', name: 'ok', visible: true, sortable: true }
    ];

    // type 's': select, 'o': plain text, 'd': date
    this.equalityFilters = [{
      val: 'a',
      name: 'Igual',
      type: 'o'
    },
      {
        val: 'b',
        name: 'Diferente',
        type: 'o'
      },
      {
        val: 'c',
        name: 'Começa por',
        type: 'o'
      },
      {
        val: 'd',
        name: 'Termina com',
        type: 'o'
      },
      {
        val: 'e',
        name: 'Contém',
        type: 'o'
      },
      {
        val: 'a',
        name: 'Igual (=)',
        type: 'd'
      },
      {
        val: 'b',
        name: 'Diferente de (≠)',
        type: 'd'
      },
      {
        val: 'c',
        name: 'Posterior a (>)',
        type: 'd'
      },
      {
        val: 'd',
        name: 'Anterior a (<)',
        type: 'd'
      },
      {
        val: 'e',
        name: 'Posterior ou igual (≥)',
        type: 'd'
      },
      {
        val: 'f',
        name: 'Anterior ou igual (≤)',
        type: 'd'
      },
      {
        val: 'a',
        name: 'Igual',
        type: 's'
      },
      {
        val: 'b',
        name: 'Diferente',
        type: 's'
      }
    ];

    this.dateFilters = this.equalityFilters.filter(x => x.type === 'd');

    this.columns = [{
      id: 'Publicacao.id',
      name: 'ID SGI',
      type: 'o'
    },
    {
      id: 'Publicacao.titulo',
      name: 'Título',
      type: 'o'
    },
    {
      id: 'Publicacao.revistaId',
      name: 'Revista',
      type: 's',
      list: this.revistas
    },
    {
      id: 'Publicacao.tituloSupra',
      name: 'Título do Livro/Revista/Conferência',
      type: 'o'
    },
    {
      id: 'Publicacao.slug',
      name: 'Slug',
      type: 'o'
    },
    {
      id: 'Publicacao.ano',
      name: 'Ano',
      type: 'o'
    },
    {
      id: 'Publicacao.doiShort',
      name: 'DOI Short',
      type: 'o'
    },
    {
      id: 'Publicacao.doiWww',
      name: 'DOI WWW',
      type: 'o'
    },
    {
      id: 'Publicacao.tipoId',
      name: 'Tipo de Publicação',
      type: 's',
      list: this.tipos
    },
    {
      id: 'PublicacaoAutor.autorDisplay',
      name: 'Autor Externo',
      type: 'o'
    },
    {
      id: 'PublicacaoAutor.investigadorId',
      name: 'Autor do ISR',
      type: 's',
      list: this.investigadores
    },
    {
      id: 'PublicacaoAreaInterdisciplinar.areaId',
      name: 'Área Interdisciplinar',
      type: 's',
      list: this.areas
    },
    {
      id: 'PublicacaoGrupoInvestigacao.grupoInvestigacaoId',
      name: 'Grupo Investigação',
      type: 's',
      list: this.gruposInvestigacao
    },
    {
      id: 'Publicacao.repositorio',
      name: 'Repositório',
      type: 'o'
    },
    {
      id: 'Publicacao.isbn',
      name: 'ISBN',
      type: 'o'
    },
    {
      id: 'Publicacao.issn',
      name: 'ISSN',
      type: 'o'
    },
    {
      id: 'Publicacao.rankingJournal',
      name: 'Ranking Journal à data Pub.',
      type: 'o'
    },
    {
      id: 'Publicacao.emDestaque',
      name: 'Em Destaque',
      type: 's',
      list: this.simnao
    },
    {
      id: 'Publicacao.scopus',
      name: 'SCOPUS',
      type: 's',
      list: this.simnao
    },
    {
      id: 'Publicacao.cited',
      name: 'Highly cited paper',
      type: 's',
      list: this.simnao
    },
    {
      id: 'Publicacao.differentInstitutionsAuthors',
      name: 'Different Institutions Authors',
      type: 's',
      list: this.simnao
    },
    {
      id: 'Publicacao.openAccess',
      name: 'Open Access',
      type: 's',
      list: this.simnao
    },
    {
      id: 'Publicacao.specialIssue',
      name: 'In Special Issue',
      type: 's',
      list: this.simnao
    },
    {
      id: 'Publicacao.internationalConference',
      name: 'In Proceedings of International Conference',
      type: 's',
      list: this.simnao
    },
    {
      id: 'Publicacao.citizenScienceApproach',
      name: 'Citizen science approach',
      type: 's',
      list: this.simnao
    },
    {
      id: 'Publicacao.performedPublicConsultation',
      name: 'Performed public consultation',
      type: 's',
      list: this.simnao
    },
    {
      id: 'Publicacao.socialJustice',
      name: 'Addresses social justice',
      type: 's',
      list: this.simnao
    },
    {
      id: 'Publicacao.internationalCollaboration',
      name: 'With foreign authors',
      type: 's',
      list: this.simnao
    },
    {
      id: 'Publicacao.developingCountries',
      name: 'Authors developing countries',
      type: 's',
      list: this.simnao
    },
    {
      id: 'Publicacao.industry',
      name: 'Authors from the industry',
      type: 's',
      list: this.simnao
    },
    {
      id: 'Publicacao.criadoPorId',
      name: 'Criado por',
      type: 's',
      list: this.users
    },
    {
      id: 'Publicacao.ok',
      name: 'Completo',
      type: 's',
      list: this.simnao
    }
    ];


    // Find relevant displayColumns from local storage
    if (localStorage.getItem('ISR_SGI_DisplayColumns')) {
      let displayColumns = JSON.parse(localStorage.getItem('ISR_SGI_DisplayColumns'));
      if (displayColumns && displayColumns.publicacao && displayColumns.publicacao.length > 0) {
        displayColumns.publicacao.forEach(c => {
          let i = this.displayColumns.findIndex(x => x.name === c.name);
          if (i >= 0) this.displayColumns[i].visible = c.visible;
        });
      }
    }

    this.customFilters = [];

    // Find customFilters from local storage
    if (localStorage.getItem('ISR_SGI_Filters')) {
      let storageFilters = JSON.parse(localStorage.getItem('ISR_SGI_Filters'));
      if (storageFilters.publicacao) this.customFilters = storageFilters.publicacao;
    }

    // Check if something comes from the URL, replace the customFilters if so
    if (this.opt.filter) {
      this.customFilters = [];
      let filters = this.opt.filter.split(":");
      filters.forEach(filter => {
        let a = filter.split("·");
        if (a.length === 3) {
          try {
            let data = {
              column: {},
              value: {}
            };
            data.column.selected = this.columns.find(f => {
              return f.id === a[0];
            });
            if (angular.isUndefined(data.column.selected)) {
              throw Error();
            }
            this.customFilters.push(data);
          } catch (e) {
            this.customFilters = [];
            this.UI.addToast('Não foi possível carregar filtros');
          }
        }
      });
      // If updated, save it to local storage
      this.setToLocalStorage('ISR_SGI_Filters', 'publicacao', this.customFilters);
    }

    // Restore list to selected if exists
    this.customFilters.forEach(f => {
      if (f.column && f.column.selected) {
        if (f.column && f.column.selected) {
          if (f.column.selected.id === 'Publicacao.revistaId')
            f.column.selected.list = this.revistas;
          if (f.column.selected.id === 'Publicacao.tipoId')
            f.column.selected.list = this.tipos;
          if (f.column.selected.id === 'PublicacaoAutor.investigadorId')
            f.column.selected.list = this.investigadores;
          if (f.column.selected.id === 'PublicacaoAreaInterdisciplinar.areaId')
            f.column.selected.list = this.areas;
          if (f.column.selected.id === 'PublicacaoGrupoInvestigacao.grupoInvestigacaoId')
            f.column.selected.list = this.gruposInvestigacao;
          if (f.column.selected.id === 'Publicacao.criadoPorId')
            f.column.selected.list = this.users;
          if (f.column.selected.id === 'Publicacao.emDestaque')
            f.column.selected.list = this.simnao;
          if (f.column.selected.id === 'Publicacao.scopus')
            f.column.selected.list = this.simnao;
          if (f.column.selected.id === 'Publicacao.cited')
            f.column.selected.list = this.simnao;
          if (f.column.selected.id === 'Publicacao.differentInstitutionsAuthors')
            f.column.selected.list = this.simnao;
          if (f.column.selected.id === 'Publicacao.openAccess')
            f.column.selected.list = this.simnao;
          if (f.column.selected.id === 'Publicacao.specialIssue')
            f.column.selected.list = this.simnao;
          if (f.column.selected.id === 'Publicacao.internationalConference')
            f.column.selected.list = this.simnao;
          if (f.column.selected.id === 'Publicacao.citizenScienceApproach')
            f.column.selected.list = this.simnao;
          if (f.column.selected.id === 'Publicacao.performedPublicConsultation')
            f.column.selected.list = this.simnao;
          if (f.column.selected.id === 'Publicacao.socialJustice')
            f.column.selected.list = this.simnao;
          if (f.column.selected.id === 'Publicacao.internationalCollaboration')
            f.column.selected.list = this.simnao;
          if (f.column.selected.id === 'Publicacao.developingCountries')
            f.column.selected.list = this.simnao;
          if (f.column.selected.id === 'Publicacao.industry')
            f.column.selected.list = this.simnao;
          if (f.column.selected.id === 'Publicacao.ok')
            f.column.selected.list = this.simnao;
        }
      }
      // Fix date filters to be moment()
      if (f.column.selected.type === 'd') {
        f.value = moment(f.value).utc();
        f.value.second(0); // We don't care about seconds
      }
    });

    // Number of selected items
    this.nSelected = 0;
    this.everythingSelected = false;

    // Load the data for the filter panel (not mandatory just to look at the table)
    this.loadData();
    // Load the table data so we can see stuff even if nothing else works
    this.getPublicacoes();
  }

  // Set to localStorage storageKey, to the value with the content for that value
  setToLocalStorage = (storageKey, value, content) => {
    let s = JSON.parse(localStorage.getItem(storageKey));
    if (s) { // If storageKey exists, check if value exists
      if (s[value]) {
        if (content) {
          s[value] = content;
        } else {
          delete s[value];
        }
      } else {
        if (content) {
          s[value] = content;
        } else {
          // Nothing...
        }
      }
    } else {
      if (content) {
        s = {};
        s[value] = content;
      } else {
        // Nothing...
      }
    }
    localStorage.setItem(storageKey, JSON.stringify(s));
  };



  // Add entry to whereObject (where/whereLiteral) or to whereOrObject depending if there are multiple selections of the same entry
  setWhereField = (data, whereObject, whereOrObject) => {
    // Check if have this entry in whereOr already
    if (whereOrObject.find(x => x.key === data.key)) { // If so, add it here then
      whereOrObject.push({
        key: data.key,
        value: data.value
      });
    } else { // Not in OR, check if there's an entry of this key in whereObject already
      if (whereObject[data.key]) { // Already have an entry for this key, transform it into an OR and add it and the new one
        whereOrObject.push({
          key: data.key,
          value: whereObject[data.key]
        });
        delete whereObject[data.key];
        whereOrObject.push({
          key: data.key,
          value: data.value
        });
      } else { // It's the first entry of this key, use whereObject only
        whereObject[data.key] = data.value;
      }
    }
  };

  // Returns a whereFields object to use in table() remote methods
  // WhereLiteral should be defined locally
  setWhereFields = (customFilters, literal, orsLiteral) => {
    let where = {};
    let whereDates = [];
    let whereNextDates = [];
    let whereLiteral = literal || {};
    let whereOrLiteral = orsLiteral || [];
    let whereOr = [];

    customFilters.forEach(f => {
      let data = {};
      data.key = f.column.selected.id;
      // Generated dates - Assuming if no . exists in field, it's always generated date
      if (f.column.selected.id.split('.').filter(Boolean).length === 1 && f.column.selected.type === 'd') {
        whereNextDates.push({
          key: data.key,
          comp: f.values.selected.val,
          value: f.value,
          format: f.column.selected.format
        });
      } else { // All other cases where fields exist in database
        if (f.column.selected.type === 'o') {
          data.value = f.value;

          this.setWhereField(data, where, whereOr);
        } else {
          if (f.column.selected.type === 'd') {
            whereDates.push({
              key: data.key,
              comp: f.values.selected.val,
              value: f.value,
              format: f.column.selected.format
            });
          } else {
            // if ID doesn't exist, use value (Yes/No cases where id doesn't exist but value does)
            if (f.value.selected.id)
              data.value = f.value.selected.id;
            else
              data.value = f.value.selected.value;

            this.setWhereField(data, whereLiteral, whereOrLiteral);
          }
        }
      }
    });
    return {
      where: where,
      whereDates: whereDates,
      whereNextDates: whereNextDates,
      whereLiteral: whereLiteral,
      whereOr: whereOr,
      whereOrLiteral: whereOrLiteral
    };
  };

  clearFilter = () => {
    this.setToLocalStorage('ISR_SGI_Filters', 'publicacao', null);
    this.customFilters = [];
    this.getPublicacoes();
  };

  getPublicacoes = () => {
    this.tableLoading = true;

    let whereFields = this.setWhereFields(this.customFilters);

    this.Publicacao.table({
      params: {
        fields: [ // edit exportPublicacoes() too
          'Publicacao.id as id',
          'Publicacao.titulo as titulo',
          'Publicacao.tituloSupra as tituloSupra',
          'Publicacao.slug as slug',
          'Publicacao.ano as ano',
          'Publicacao.repositorio as repositorio',
          'Publicacao.doiShort as doiShort',
          'Publicacao.doiWww as doiWww',
          'Publicacao.scopus as scopus',
          'Publicacao.isbn as isbn',
          'Publicacao.issn as issn',
          'Publicacao.emDestaque as emDestaque',
          'Publicacao.revistaId as revistaId',
          'Publicacao.rankingJournal as rankingJournal',
          'Publicacao.cited as cited',
          'Publicacao.differentInstitutionsAuthors as differentInstitutionsAuthors',
          'Publicacao.openAccess as openAccess',
          'Publicacao.specialIssue as specialIssue',
          'Publicacao.internationalConference as internationalConference',
          'Publicacao.citizenScienceApproach as citizenScienceApproach',
          'Publicacao.performedPublicConsultation as performedPublicConsultation',
          'Publicacao.socialJustice as socialJustice',
          'Publicacao.internationalCollaboration as internationalCollaboration',
          'Publicacao.developingCountries as developingCountries',
          'Publicacao.industry as industry',
          'Publicacao.ok as ok',
          'Publicacao.criadoPorId as criadoPorId',
          'PublicacaoTipo.designacao as tipo',
          'Revista.nome as revista',
          'User.name as criadoPor',
        ],
        from: ['Publicacao', 'PublicacaoTipo', 'User', 'PublicacaoAutor', 'PublicacaoAreaInterdisciplinar', 'Revista', 'PublicacaoGrupoInvestigacao'],
        referencesOrigin: [undefined, undefined, undefined, 'PublicacaoAutor.publicacaoId', 'PublicacaoAreaInterdisciplinar.publicacaoId', undefined, 'PublicacaoGrupoInvestigacao.publicacaoId'],
        references: [undefined, 'Publicacao.tipoId', 'Publicacao.criadoPorId', 'Publicacao.id', 'Publicacao.id', 'Publicacao.revistaId', 'Publicacao.id'],
        where: whereFields.where,
        whereLiteral: whereFields.whereLiteral,
        whereDates: whereFields.whereDates,
        whereOr: whereFields.whereOr,
        whereOrLiteral: whereFields.whereOrLiteral,
        groupBy: ['Publicacao.id'], // Do groupBy when having N:M relation
        order: this.opt.order,
        sort: this.opt.sort,
        limit: this.opt.items,
        skip: (this.opt.page - 1) * this.opt.items,
      }
    }).$promise.then(res => {
      let page = this.opt.page;
      let items = this.opt.items;

      let total = res.count;

      this.start = total > 0 ? (page - 1) * items + 1 : 0;
      if ((this.start - 1 + items) >= total) {
        this.end = total;
      } else {
        this.end = Number.parseInt(this.start - 1 + items);
      }

      // Process output
      // res.data.forEach(i => {
      //
      // });

      this.publicacoes = res.data;
      this.total = total;
      this.tableLoading = false;
    }).catch((error) => {
      console.log(error);
      this.UI.addToast("Erro na busca de publicações. Verifique a ligação");
    });
  };

  isColumnVisible = (column) => {
    let f = this.displayColumns.find(x => x.name === column);
    return _.isEmpty(f) ? false : f.visible;
  };

  selectVisibleColumns = () => {
    let options = {
      size: 'md',
      template: require('./columns.dialog.html'),
      controller: ['$dialog', '$scope', (dialog, scope) => {
        scope.title = "Editar Campos Visíveis";
        scope.displayColumns = angular.copy(this.displayColumns);

        scope.ok = () => {
          dialog.close(scope);
        };

        scope.cancel = () => {
          dialog.dismiss('cancel');
        };
      }]
    };

    let modal = this.UI.showDialog(options);

    modal.then((res) => {
      if (res && res.displayColumns) {
        this.displayColumns = angular.copy(res.displayColumns);
        // Save it to local storage
        this.setToLocalStorage('ISR_SGI_DisplayColumns', 'publicacao', this.displayColumns);
      }
    });
  };

  loadData = () => {
    this.PublicacaoTipo.find({
    }).$promise.then(tipos => {
      tipos.forEach(t => {
        t.name = t.designacao;
      });
      this.tipos = tipos;
      this.filtersLoaded[1] = 1;
    }).catch(e => {
      this.tipos = [];
      this.filtersLoaded[1] = 1;
      this.UI.addToast("Erro de carregamento de dados para filtragem (Tipos de Publicação).");
    });

    this.User.find({
      filter: {
        where: {
          email: {like: '%isr.uc.pt'} // Only show @ISR users
        }
      }
    }).$promise.then(users => {
      // users.forEach(t => {
      //   t.name = t.designacao;
      // });
      this.users = users;
      this.filtersLoaded[2] = 1;
    }).catch(e => {
      this.users = [];
      this.filtersLoaded[2] = 1;
      this.UI.addToast("Erro de carregamento de dados para filtragem (Utilizadores).");
    });

    this.Investigador.find({
    }).$promise.then(investigadores => {
      investigadores.sort((a, b) => a.nome.localeCompare(b.nome));
      investigadores.forEach(t => {
        t.name = t.nome;
      });
      this.investigadores = investigadores;
      this.filtersLoaded[3] = 1;
    }).catch(e => {
      this.investigadores = [];
      this.filtersLoaded[3] = 1;
      this.UI.addToast("Erro de carregamento de dados para filtragem (Investigadores).");
    });

    this.AreaInterdisciplinar.find({
    }).$promise.then(areas => {
      areas.forEach(t => {
        t.name = t.designacao;
      });
      this.areas = areas;
      this.filtersLoaded[4] = 1;
    }).catch(e => {
      this.areas = [];
      this.filtersLoaded[4] = 1;
      this.UI.addToast("Erro de carregamento de dados para filtragem (Áreas Interdisciplinares).");
    });
    this.Revista.find({
      filter: {
        fields: {id: true, nome: true}
      }
    }).$promise.then(revistas => {
      revistas.sort((a, b) => a.nome.localeCompare(b.nome));
      revistas.forEach(t => {
        t.name = t.nome;
      });
      this.revistas = revistas;
      this.filtersLoaded[5] = 1;
    }).catch(e => {
      console.log(e);
      this.revistas = [];
      this.filtersLoaded[5] = 1;
      this.UI.addToast("Erro de carregamento de dados para filtragem (Revistas).");
    });

    this.GrupoInvestigacao.find({
    }).$promise.then(gruposInvestigacao => {
      gruposInvestigacao.forEach(t => {
        t.name = t.designacao;
      });
      this.gruposInvestigacao = gruposInvestigacao;
      this.filtersLoaded[6] = 1;
    }).catch(e => {
      this.gruposInvestigacao = [];
      this.filtersLoaded[6] = 1;
      this.UI.addToast("Erro de carregamento de dados para filtragem (Grupos Investigação).");
    });

  };

  sort = key => {
    if (!key.sortable) {
      return;
    }
    let keyname = key.name;
    if (this.opt.order === keyname)
      this.opt.page = 1;
    this.opt.order = keyname;
    this.opt.sort = this.opt.sort === 'asc' ? 'desc' : 'asc';
    this.$state.go('app.publicacao.list', this.opt, {
      // prevent the events onStart and onSuccess from firing
      notify: false,
      // prevent reload of the current state
      reload: false,
      // replace the last record when changing the params so you don't hit the back button and get old params
      location: 'replace',
      // inherit the current params on the url
      inherit: true
    });
    this.getPublicacoes();
  };

  item = val => {
    this.opt.items = val;
    this.$state.go('app.publicacao.list', this.opt, {
      // prevent the events onStart and onSuccess from firing
      notify: false,
      // prevent reload of the current state
      reload: false,
      // replace the last record when changing the params so you don't hit the back button and get old params
      location: 'replace',
      // inherit the current params on the url
      inherit: true
    });
    this.getPublicacoes();
  };

  page = sum => {
    this.opt.page += sum;
    if (this.opt.page < 1)
      this.opt.page = 1;
    if (this.opt.page > Math.ceil(this.total / this.opt.items))
      this.opt.page = Math.ceil(this.total / this.opt.items);
    this.$state.go('app.publicacao.list', this.opt, {
      // prevent the events onStart and onSuccess from firing
      notify: false,
      // prevent reload of the current state
      reload: false,
      // replace the last record when changing the params so you don't hit the back button and get old params
      location: 'replace',
      // inherit the current params on the url
      inherit: true
    });
    this.getPublicacoes();
  };

  openFilter = () => {
    let result = this.filtersLoaded.reduce((a, b) => a + b, 0);

    if (result !== this.filtersLoaded.length) {
      this.UI.addToast("A carregar dados para filtragem, por favor tente novamente");
      return;
    }

    if (!this.tipos.length && !this.users.length && !this.investigadores.length && !this.areas.length && !this.revistas.length) {
      this.UI.addToast("Erro ao carregar dados de filtragem. Por favor recarregue a página.");
      return;
    }

    this.columns.forEach(f => {
      if (f.id === 'Publicacao.revistaId')
        f.list = this.revistas;
      if (f.id === 'Publicacao.tipoId')
        f.list = this.tipos;
      if (f.id === 'PublicacaoAutor.investigadorId')
        f.list = this.investigadores;
      if (f.id === 'PublicacaoAreaInterdisciplinar.areaId')
        f.list = this.areas;
      if (f.id === 'PublicacaoGrupoInvestigacao.grupoInvestigacaoId')
        f.list = this.gruposInvestigacao;
      if (f.id === 'Publicacao.criadoPorId')
        f.list = this.users;
      if (f.id === 'Publicacao.emDestaque')
        f.list = this.simnao;
      if (f.id === 'Publicacao.scopus')
        f.list = this.simnao;
      if (f.id === 'Publicacao.cited')
        f.list = this.simnao;
      if (f.id === 'Publicacao.differentInstitutionsAuthors')
        f.list = this.simnao;
      if (f.id === 'Publicacao.openAccess')
        f.list = this.simnao;
      if (f.id === 'Publicacao.specialIssue')
        f.list = this.simnao;
      if (f.id === 'Publicacao.internationalConference')
        f.list = this.simnao;
      if (f.id === 'Publicacao.citizenScienceApproach')
        f.list = this.simnao;
      if (f.id === 'Publicacao.performedPublicConsultation')
        f.list = this.simnao;
      if (f.id === 'Publicacao.socialJustice')
        f.list = this.simnao;
      if (f.id === 'Publicacao.internationalCollaboration')
        f.list = this.simnao;
      if (f.id === 'Publicacao.developingCountries')
        f.list = this.simnao;
      if (f.id === 'Publicacao.industry')
        f.list = this.simnao;
      if (f.id === 'Publicacao.ok')
        f.list = this.simnao;
    });

    // Copy column to be used in
    this.editColumns = angular.copy(this.columns);

    // Restore list to selected
    this.customFilters.forEach(f => {
      if (f.column && f.column.selected) {
        if (f.column.selected.id === 'Publicacao.revistaId')
          f.column.selected.list = this.revistas;
        if (f.column.selected.id === 'Publicacao.tipoId')
          f.column.selected.list = this.tipos;
        if (f.column.selected.id === 'PublicacaoAutor.investigadorId')
          f.column.selected.list = this.investigadores;
        if (f.column.selected.id === 'PublicacaoAreaInterdisciplinar.areaId')
          f.column.selected.list = this.areas;
        if (f.column.selected.id === 'PublicacaoGrupoInvestigacao.grupoInvestigacaoId')
          f.column.selected.list = this.gruposInvestigacao;
        if (f.column.selected.id === 'Publicacao.criadoPorId')
          f.column.selected.list = this.users;
        if (f.column.selected.id === 'Publicacao.emDestaque')
          f.column.selected.list = this.simnao;
        if (f.column.selected.id === 'Publicacao.scopus')
          f.column.selected.list = this.simnao;
        if (f.column.selected.id === 'Publicacao.cited')
          f.column.selected.list = this.simnao;
        if (f.column.selected.id === 'Publicacao.differentInstitutionsAuthors')
          f.column.selected.list = this.simnao;
        if (f.column.selected.id === 'Publicacao.openAccess')
          f.column.selected.list = this.simnao;
        if (f.column.selected.id === 'Publicacao.specialIssue')
          f.column.selected.list = this.simnao;
        if (f.column.selected.id === 'Publicacao.internationalConference')
          f.column.selected.list = this.simnao;
        if (f.column.selected.id === 'Publicacao.citizenScienceApproach')
          f.column.selected.list = this.simnao;
        if (f.column.selected.id === 'Publicacao.performedPublicConsultation')
          f.column.selected.list = this.simnao;
        if (f.column.selected.id === 'Publicacao.socialJustice')
          f.column.selected.list = this.simnao;
        if (f.column.selected.id === 'Publicacao.internationalCollaboration')
          f.column.selected.list = this.simnao;
        if (f.column.selected.id === 'Publicacao.developingCountries')
          f.column.selected.list = this.simnao;
        if (f.column.selected.id === 'Publicacao.industry')
          f.column.selected.list = this.simnao;
        if (f.column.selected.id === 'Publicacao.ok')
          f.column.selected.list = this.simnao;
      }
    });
    // Copy customFilter to another variable so we can edit it all we want
    this.editCustomFilters = angular.copy(this.customFilters);
    // Show side panel
    this.fs = true;
  };

  oldColumn = ($item, i) => {
    //Infinite Scroll Magic
    i.infiniteScroll = {};
    i.infiniteScroll.numToAdd = 20;
    i.infiniteScroll.currentItems = 20;

    if ($item.type === 's')
      i.value = {};
    else
      i.value = "";

    i.addMoreItems = function () {
      i.infiniteScroll.currentItems += i.infiniteScroll.numToAdd;
    };
  };

  applyFilter = () => {
    // Parse values from sidebar
    this.editCustomFilters = _.filter(this.editCustomFilters, f => f.column && !_.isEmpty(f.value));

    // Remove list for column, no need to save it
    this.editCustomFilters.forEach(f => {
      if (f.column && f.column.selected) {
        f.column.selected.list = [];
      }
      // Fix date filters to be moment()
      if (f.column.selected.type === 'd') {
        f.value = moment(f.value).utc();
        f.value.second(0); // We don't care about seconds
      }
    });

    this.customFilters = angular.copy(this.editCustomFilters);

    this.setToLocalStorage('ISR_SGI_Filters', 'publicacao', this.customFilters);
    this.fs = false;
    // Go to first page for results
    this.opt.page = 1;
    this.$state.go('app.publicacao.list', this.opt, {
      // prevent the events onStart and onSuccess from firing
      notify: false,
      // prevent reload of the current state
      reload: false,
      // replace the last record when changing the params so you don't hit the back button and get old params
      location: 'replace',
      // inherit the current params on the url
      inherit: true
    });

    this.getPublicacoes();
  };

  hasSelect = () => {
    return _.some(this.publicacoes, a => a.selected === true);
  };

  selectAll = () => {
    if (this.allSelected) { // Not all are selected, select all
      this.publicacoes.forEach(a => {
        a.selected = true;
      });
      this.nSelected = this.publicacoes.length;
    } else { // Remove all selections
      this.publicacoes.forEach(a => {
        a.selected = false;
      });
      this.nSelected = 0;
    }
    this.everythingSelected = false;
  };

  selectEverything = (type) => {
    if (!type) {
      this.publicacoes.forEach(a => {
        a.selected = false;
      });
      this.nSelected = 0;
      this.allSelected = false;
    }
    this.everythingSelected = !!type;
  };

  selectItem = () => {
    this.nSelected = _.filter(this.publicacoes, r => r.selected).length;
    this.allSelected = this.nSelected >= this.publicacoes.length;
    this.everythingSelected = false;
  };

  validityInfo = (publicacaoId) => {
    let wait = this.UI.showWaiting();
    this.PublicacaoService.validityInfo(publicacaoId).then(data => {
      wait.close();
      if (data && data.length > 0) {
        let title = "Publicação - Informação em falta";
        let introText = "A lista seguinte mostra a informação obrigatória necessária";
        let instance = this.UI.showDialog({
          size: 'md',
          template: require('../../interface/modals/show-list.html'),
          controller: ['$scope', ($scope) => {
            $scope.title = title;
            $scope.introText = introText;
            $scope.list = data;
            $scope.ok = function () {
              $scope.$close();
            };
          }]
        });
        instance.finally(() => {
          // Nothing should happen
        });
      } else {
        this.UI.addToast("Publicação válida");
      }
    }).catch(error => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível obter dados de publicação. Verifique a ligação");
    });
  };

  deletePublicacao = (publicacao) => {
    this.PublicacaoService.confirmDeletePublicacao(publicacao).then(() => {
      this.getPublicacoes();
    }).catch(error => {
      console.log(error);
      this.getPublicacoes();
    });
  };
}

PublicacaoListController.$inject = ['$state', 'Group', 'UIService', 'Publicacao', 'PublicacaoService', 'PublicacaoTipo', 'Investigador', 'User', 'AreaInterdisciplinar', 'Revista', 'GrupoInvestigacao'];
